import { render } from "./KanbanView.vue?vue&type=template&id=d5677724&scoped=true&ts=true"
import script from "./KanbanView.vue?vue&type=script&lang=ts"
export * from "./KanbanView.vue?vue&type=script&lang=ts"

import "./KanbanView.vue?vue&type=style&index=0&id=d5677724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5677724"]])

export default __exports__